import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["playlistId"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'utils/api';
import { contentQueryKeys } from 'actions/content';
function useUpdatePlaylistAutoShares(_ref) {
  var playlistId = _ref.playlistId,
    options = _objectWithoutProperties(_ref, _excluded);
  var queryClient = useQueryClient();
  function updateAutoShares(_x) {
    return _updateAutoShares.apply(this, arguments);
  }
  function _updateAutoShares() {
    _updateAutoShares = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(autoShare) {
      var type, teams, body;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            type = autoShare.type, teams = autoShare.teams;
            if (!(type === 'null')) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return", api('delete', '/api/teamShare', null, {
              playlist_id: playlistId,
              action: 'disable'
            }));
          case 1:
            if (!(type === 'teams' && !teams.length)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", api('delete', '/api/teamShare', null, {
              playlist_id: playlistId,
              action: 'delete'
            }));
          case 2:
            if (!(type === 'teams')) {
              _context.next = 3;
              break;
            }
            body = teams.map(function (team) {
              return {
                team_id: team.id,
                playlist_id: playlistId
              };
            });
            return _context.abrupt("return", api('post', '/api/query/teamSharing', null, body));
          case 3:
            return _context.abrupt("return", api('post', '/api/query/teamSharing', null, {
              team_id: null,
              playlist_id: playlistId
            }));
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _updateAutoShares.apply(this, arguments);
  }
  var _useMutation = useMutation(_objectSpread(_objectSpread({
      mutationFn: updateAutoShares
    }, options), {}, {
      onSuccess: function onSuccess() {
        queryClient.invalidateQueries({
          queryKey: contentQueryKeys.contentAutoShareRecipientCount(playlistId)
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    updatePlaylistAutoShares: mutateAsync
  });
}
export default useUpdatePlaylistAutoShares;